var map = {
	"./Auth/routes.js": "dfc8",
	"./CMS/routes.js": "2860",
	"./Campaigns/routes.js": "7dd8",
	"./Customers/routes.js": "714e",
	"./Dashboard/routes.js": "e226",
	"./Orders/routes.js": "d02a",
	"./Products/routes.js": "05a9",
	"./Quotes/routes.js": "9fe1",
	"./Rules/routes.js": "fbbb",
	"./Settings/routes.js": "d143"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8ffe";